"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxEditor = void 0;
var tax_75_svg_1 = __importDefault(require("@ClientAssets/icons/color/tax-75.svg"));
var jquery_1 = __importDefault(require("jquery"));
var OverlayEditorLayout_1 = require("Common/OverlayEditorLayout/OverlayEditorLayout");
var QuoteAccountSettingsUpdater_1 = require("Project/Modules/QuoteV2/QuoteAccountSettingsUpdater");
var TaxEditor = (function () {
    function TaxEditor(make, createUi, accountQuoteSettings, utils, $timeout, Tooltip, telemetry) {
        var _this = this;
        this.apiUpdater = make(QuoteAccountSettingsUpdater_1.QuoteAccountSettingsUpdater, {
            settingsName: "taxes",
            transformFunction: function (_a) {
                var id = _a.id, name = _a.name, percent = _a.percent;
                return ({ id: id, name: name, percent: percent });
            },
        });
        var blankTax = {
            name: "",
            percent: 0,
        };
        var taxes = accountQuoteSettings.taxes;
        var taxListComponent = createUi(require("./TaxEditor.html"), {
            taxes: taxes,
            removeTax: function (index) {
                taxes.splice(index, 1);
                _this.apiUpdater.debouncedApiUpdate();
                return telemetry.trackOnly("Quote Block Tax Deleted", {}, { blockIntercom: true });
            },
            onInputChange: function () {
                _this.apiUpdater.debouncedApiUpdate();
            },
        });
        var makeMissingTaxInfoTooltip = function (id) {
            return make(Tooltip, {
                targetSelector: "#".concat(id),
                options: {
                    container: ".list.main-content",
                    position: "bottom",
                    spacing: 0,
                    stringContent: "A tax needs a name",
                    hideAfter: 3000,
                    customTheme: "error-theme",
                },
            });
        };
        var getTaxId = function () {
            var id = utils.uniqueId();
            return id.startsWith("_") ? "tax".concat(id) : id;
        };
        var createNewTaxItem = function () {
            var taxItem = __assign(__assign({}, blankTax), { id: getTaxId() });
            taxes.push(taxItem);
            _this.apiUpdater.debouncedApiUpdate();
            telemetry.trackOnly("Quote Block Tax Added");
            return $timeout(function () { return (0, jquery_1.default)(".tax-item").last().find(".name").trigger("focus"); }, 20);
        };
        var isValid = function () {
            var index = taxes.findIndex(function (tax) { return !tax.name; });
            if (index >= 0) {
                var tooltip = makeMissingTaxInfoTooltip(taxes[index].id);
                tooltip.show();
                return false;
            }
            return true;
        };
        var taxEditor = make(OverlayEditorLayout_1.OverlayEditorLayout, {
            iconSrc: tax_75_svg_1.default,
            listComponent: taxListComponent,
            createNewItem: createNewTaxItem,
            title: "Taxes",
            description: "Set up taxes for your quotes.",
            isValid: isValid,
        });
        this.show = function () { return taxEditor.show(); };
    }
    TaxEditor.prototype.show = function () { };
    return TaxEditor;
}());
exports.TaxEditor = TaxEditor;
